// extracted by mini-css-extract-plugin
export default {"eventCard":"EventCard_eventCard__xp+K-"};